import { useQuery } from "react-query";
import {
  PendidikanResponse,
  PendidikanSelectionResponse,
} from "../../../../models/Pendidikan";
import { RiwayatPendidikanResponse } from "../../../../models/RiwayatPendidikan";
import { getApiInstance } from "../../../api";
import queryWrapper from "../../queryWrapper";
import { allPendidikanKey } from "../Pendidikan/useFetchAllPendidikan";
import ApiClient from "../../../apiClient";

export async function allPendidikanSelection(): Promise<
  PendidikanSelectionResponse[]
> {
  const res = await ApiClient.get(`/PendidikanSelection`);
  return res.data;
}

export default function useFetchAllPendidikanSelection() {
  return useQuery([allPendidikanKey], queryWrapper(allPendidikanSelection));
}
